import { jsx } from "react/jsx-runtime";
import { Heading, CustomPropTypes } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockHeading = ({
  attrs
}) => {
  const {
    content,
    textAlign = "inherit",
    level,
    margin,
    ...rest
  } = attrs;
  const interactiveContent = makeContentInteractive(content);
  const attributes = {
    as: "h2",
    fontType: {
      default: "h2"
    },
    fontFamily: "sansSerif",
    marginBottom: "sm",
    fontColor: "",
    textAlign,
    ...rest
  };
  if (level && !attrs.fontType) {
    attributes.fontType = `h${level}`;
  }
  if (typeof attributes.fontType === "string") {
    const mappings = {
      h0: {
        default: "h0",
        sm_lte: "h2"
      },
      h1: {
        default: "h1",
        sm_lte: "h2"
      },
      h2: {
        default: "h2",
        sm_lte: "h3"
      },
      h3: {
        default: "h3"
      },
      h4: {
        default: "h4"
      },
      h5: {
        default: "h5"
      },
      h6: {
        default: "h6"
      }
    };
    if (!attrs.as) {
      attributes.as = attributes.fontType;
    }
    attributes.fontType = mappings[attributes.fontType];
  }
  return /* @__PURE__ */ jsx(Heading, { placement: usePlacement(), ...attributes, ...margin, children: interactiveContent });
};
BlockHeading.propTypes = {
  attrs: PropTypes.shape({
    as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    fontType: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    content: PropTypes.string,
    textAlign: PropTypes.string,
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    }))
  }),
  index: PropTypes.number
};
export {
  BlockHeading as default
};
